export const CompanyRoles = {
    USERS: 'users',
    VIEWERS: 'viewers',
};
